import React from 'react';

export function Dot({ color = 'var(--ok)', size = 6, className, style }) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        ...style,
      }}
    />
  );
}

export default Dot;
